/**
 * Turns the Guide card rows into carousels on mobile, using the theme's own
 * <css-slider> component (assets/component-slider.js).
 *
 * Why this file exists instead of relying on the component's watchCSS option:
 * watchCSS makes the component read its own ::after content to decide whether
 * to initialise, and it does that the moment the custom element upgrades --
 * which on a real page load can happen BEFORE the section's stylesheet has
 * applied. The value is then an empty string, the slider silently stays off,
 * and it only re-checks on a window resize. That is exactly what happened on
 * mobile: one row became a carousel and the other did not, depending on cache
 * timing. matchMedia has no such race.
 *
 * The options still pass watchCSS: true, which is what stops the component
 * from auto-initialising on desktop in its own constructor. This controller
 * then owns the actual on/off decision, and calls the component's own public
 * initSlider() / destroySlider() so all the behaviour stays in one place.
 */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function sliders() {
    return Array.prototype.slice.call(
      document.querySelectorAll('css-slider.guide-slider')
    );
  }

  function sync() {
    sliders().forEach(function (el) {
      if (typeof el.initSlider !== 'function') return;
      try {
        if (mq.matches && !el.sliderEnabled) {
          el.initSlider();
        } else if (!mq.matches && el.sliderEnabled) {
          el.destroySlider();
        }
      } catch (e) {
        // A failed slider must never take the section down: the row simply
        // stays a plain stacked grid, which is readable.
        if (window.console) console.warn('[guide-slider]', e);
      }
    });
  }

  function start() {
    sync();
    // Custom elements can upgrade after DOMContentLoaded; re-check once the
    // page has fully settled.
    window.addEventListener('load', sync);
    if (mq.addEventListener) {
      mq.addEventListener('change', sync);
    } else if (mq.addListener) {
      mq.addListener(sync);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
